import React from "react";
import styles from "./styles.module.css";

const Toggle = ({ label, checked, onChange }) => {
  return (
    <div className={styles.toggle}>
      <label className={styles.switch}>
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
          className={`${styles.input} ${styles.checkbox}`}
        />
        <span className={styles.slider}></span>
      </label>
      <label>{label}</label>
    </div>
  );
};

export default Toggle;
